<template lang="pug">
  div
    loading-overlay(:is-loading="isSubmitting")
    form(
      ref="form"
      action="/users/heatmaps"
      method="post"
      @submit.prevent="handleSubmit"
    )
      .form-inputs
        .form-group
          label URL
          span.badge.badge-primary.ml-2 *必須
          div.d-flex
            input.form-control.w-100(
              name="url"
              v-model="formData.url",
              :disabled="is_edit"
              placeholder="https://sitelead.net（URLを入力してください）"
              :class="{'is-invalid': ($v.formData.url.$invalid && $v.formData.url.$dirty) || error_message, 'is-valid': !$v.formData.url.$invalid && $v.formData.url.$dirty && !error_message }")
            //button.ml-3.btn.btn-primary(type="button" :disabled="is_edit" @click="checkUrl") ヒートマップ計測可能か確認する
          template(v-if="$v.formData.url.$dirty")
            .invalid-feedback(v-if="!$v.formData.url.required") URLを入力してください
            .invalid-feedback(v-if="!$v.formData.url.validUrl") URLはhttpsで始まる必要があります
          .invalid-feedback(v-if="error_message" style="display: block;") {{ error_message }}
          p.text-gray パラメータの指定が可能です。パラメータ付きURLを登録した場合、そのURLでヒートマップが計測されます。
        .form-group.mt-2
          label 名前
          span.badge.badge-primary.ml-2 *必須
          input.form-control(
            name="name"
            v-model="formData.name",
            placeholder="例: 通販サイトTOPページ／記事ページ"
            :class="{ 'is-invalid': $v.formData.name.$invalid && $v.formData.name.$dirty, 'is-valid': !$v.formData.name.$invalid && $v.formData.name.$dirty }")
          template(v-if="$v.formData.name.$dirty")
            .invalid-feedback(v-if="!$v.formData.name.required") 名前を入力してください
            .invalid-feedback(v-if="!$v.formData.name.maxLength255") 名前は255文字以内で入力してください

      p(style="color: green;" v-if="valid_url === true") タグの設置が確認できました。ヒートマップ計測が可能です。
      p(style="color: red; white-space: pre-line;" v-if="valid_url === 'already_created_heatmap'")
        | 該当のURLは追加済みです。
        br
        a(href="/users/heatmaps" style="color: red; text-decoration: underline;") ヒートマップ一覧 
        | から、該当のURLを検索し、
        | 計測をONにするとヒートマップ計測が開始します。
      p(style="color: red; white-space: pre-line;" v-if="valid_url === 'validation_failed'")
        | タグの設置が確認できませんでした。ヒートマップ計測ができません。
        | ヒートマップ計測ページにタグが設置されているか確認してください。
        | タグ設置方法は
        a(href="/users/tag_domains") こちら

        .form-actions
          button.btn.btn-default(type="submit" v-if="is_edit") 編集する
          button.btn.btn-default(type="submit" v-else) ヒートマップ計測を開始する

</template>

<script>
import axios from '../plugins/axios'
import {helpers, required} from "vuelidate/lib/validators";
import LoadingOverlay from "./parts/loading_overlay.vue";

const startsWithHttps = helpers.regex('startsWithHttps', /^(https?:\/\/.+)$/);
const maxLength255 = (value) => !helpers.req(value) || value.length <= 255;

export default {
  props: {
    heatmap: Object,
    is_edit: Boolean
  },
  data() {
    return {
      formData: {
        id: this.heatmap?.id || '',
        name: this.heatmap?.name || '',
        url: this.heatmap?.url || '',
      },
      valid_url: null,
      error_message: null,
      isSubmitting: false
    };
  },
  components: {
    LoadingOverlay
  },
  validations() {
    return {
      formData: {
        name: {required, maxLength255},
        url: {required, validUrl: startsWithHttps},
      }
    }
  },
  methods: {
    async handleSubmit() {
      if (this.valid_url === false) {
        alert("ヒートマップ計測可能なURLを入力してください。");
        return;
      }

      if (this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;

      if (!this.is_edit) {
        await this.checkUrl(this.formData.url);

        if (this.error_message) {
          this.isSubmitting = false;
          return;
        }
      }

      this.$v.$touch();
      if (this.$v.formData.$invalid) {
        console.error("Validation failed");
        this.isSubmitting = false;
        return;
      }

      try {
        const url = this.heatmap?.id > 0 ? '/api/v1/heatmaps/update' : '/api/v1/heatmaps/create';
        const response = await axios.post(url, this.formData);

        if (!response.data.is_error) {
          const nextPageUrl = '/users/heatmaps';
          window.location.href = nextPageUrl;
        }
      } catch (error) {
        console.error("Error occurred:", error);
        if (error.response) {
          // サーバーからエラーレスポンスが返ってきた場合
          const message = error.response.data?.message || 'エラーが発生しました。';
          this.error_message = message;
        } else {
          // ネットワークエラー等
          this.error_message = 'エラーが発生しました。時間をおいて再度お試しください。';
        }
      } finally {
        this.isSubmitting = false;
      }
    },
    async checkUrl() {
      this.valid_url = null;
      this.error_message = null;

      if(this.formData.url.length === 0){
        this.error_message = "ヒートマップを計測するURLを指定してください。"
        return
      }

      const selectedDomainElement = document.querySelector(".custom-option");
      let domainValue = selectedDomainElement.dataset.value;
      const userSelectedDomain = domainValue ? new URL(domainValue.trim()).hostname : null;

      try {
        const inputDomain = new URL(this.formData.url).hostname;

        if (inputDomain !== userSelectedDomain) {
          this.error_message = "選択されているWebサイトと一致しません。管理画面上部の「Webサイト」箇所をご確認ください。"
          return;
        }
      } catch (error) {
        this.error_message = "選択されているWebサイトと一致しません。管理画面上部の「Webサイト」箇所をご確認ください。"
        return;
      }

      // this.formData.url = this.formData.url.trim().replace(/\s+/g, '');
      //
      // try {
      //   const response = await axios.post('/api/v1/tag_domains/validate_url', {
      //     url: this.formData.url
      //   });
      //
      //   if (response.data.code == 409) {
      //     this.error_message = '該当のURLは追加済みです。';
      //   } else if (!response.data.is_valid) {
      //     this.valid_url = "validation_failed";
      //   } else {
      //     this.valid_url = response.data.is_valid;
      //   }
      // } catch (error) {
      //   console.error('Error checking URL:', error.response ? error.response.data : error.message);
      //   this.valid_url = "validation_failed";
      // }
    }
  }
}
</script>
